// extracted by mini-css-extract-plugin
module.exports = {"odTitle":"od-share_odTitle__2URol","nodata":"od-share_nodata__1D6g-","chartCanvas":"od-share_chartCanvas__1nF2Z"};